import actionCreatorFactory from 'typescript-fsa';
import { ConnectedCompanies, CustomerDestinations } from '../models/CommonParam';

const actionCreator = actionCreatorFactory('CommonParam');

export const CommonParamActions = {
    setMandt: actionCreator<string>('setMandt'),

    // カスタマー接続先を取得
    getCustomerDestinations: actionCreator('getCustomerDestinations'),
    // カスタマー接続先を保持
    setCustomerDestinations: actionCreator<CustomerDestinations>('setCustomerDestinations'),
    // 接続先企業名を取得
    getConnectedCompanies: actionCreator('getConnectedCompanies'),
    // 接続先企業名を保持
    setConnectedCompanies: actionCreator<ConnectedCompanies>('setConnectedCompanies')
}